import React, { useState, useEffect, useRef } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import Header from "./Header";
import Sidebar from "./Sidebar";
import BottomNav from "./BottomNav";

const Layout = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [collapsed, setCollapsed] = useState(false);
  const navigate = useNavigate();
  const blockedRef = useRef(false);

  const safeNavigate = (to) => {
    blockedRef.current = false;
    window.dispatchEvent(new CustomEvent('beforeNavigate', { detail: { to } }));
    setTimeout(() => {
      if (!blockedRef.current) {
        navigate(to);
      }
    }, 60);
  };

  useEffect(() => {
    window.__blockNavigation = () => { blockedRef.current = true; };
    window.__safeNavigate = safeNavigate;
    return () => {
      delete window.__blockNavigation;
      delete window.__safeNavigate;
    };
  }, [navigate]);

  useEffect(() => {
    document.body.style.overscrollBehavior = 'none';
    document.documentElement.style.overscrollBehavior = 'none';
    return () => {
      document.body.style.overscrollBehavior = '';
      document.documentElement.style.overscrollBehavior = '';
    };
  }, []);

  return (
    <div className="flex h-dvh overflow-hidden bg-background dark:bg-[#1a1c1c]">
      {/* Overlay mobile */}
      <div
        className={`fixed inset-0 bg-black/50 z-[90] transition-all duration-300 ease-in-out lg:hidden
          ${sidebarOpen ? 'opacity-100 visible' : 'opacity-0 invisible'}`}
        onClick={() => setSidebarOpen(false)}
      />

      {/* Sidebar */}
      <Sidebar
        isOpen={sidebarOpen}
        onClose={() => setSidebarOpen(false)}
        collapsed={collapsed}
        onToggleCollapse={() => setCollapsed(!collapsed)}
      />

      {/* Main Area - dynamic margin */}
      <div className={`flex-1 flex flex-col min-w-0 h-dvh overflow-hidden transition-all duration-300 ${collapsed ? 'lg:ml-[72px]' : 'lg:ml-64'}`}>
        <Header onMenuClick={() => setSidebarOpen(true)} />
        <main className="flex-1 overflow-y-auto overscroll-none p-3 pb-[85px] md:p-5 md:pb-5 lg:p-6 lg:pb-6">
          <Outlet />
        </main>
      </div>

      <BottomNav />
    </div>
  );
};

export default Layout;